import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import Vas from '../../../Vas';
import '../../../css/CreateLegalGuardian.css';
import { ExtendedButton,DateField,MessageBox,TextField, SelectField, AutocompleteField } from 'component-lib';
import { TranslateGender,DateTimeHelper, CheckValues } from 'utils-lib';
import { RequestAjaxClass, StreetsModel, CustomerModel, AdditionalAddressesModel } from 'models-lib';

var moment = require('moment');
moment().format();

class CreateLegalGuardian extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.CustomerId = props.match.params.CustomerId;
        this.state.CustomerText = '';
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.CustomerModel = new CustomerModel([this],null,this.Request);
        this.StreetsModel = new StreetsModel([this],"StreetsCustomer",this.Request);
        this.AddressModel = new AdditionalAddressesModel([this],null,this.Request2);
    }

    componentDidMount(){
      let me = this;
      me.setState({ requiredFields:[
        me.refs.name,
        me.refs.firstName,
        me.refs.dateOfBirth,
        me.refs.zip, 
        me.refs.city,
        me.refs.street,
        me.refs.houseNumber]
        //requiredSelectField : [me.refs.gender]
      },()=>{
            for (let i=0; i<me.state.requiredFields.length; i++){
                if (me.state.requiredFields[i].props.IsRequired){
                  me.state.requiredFields[i].setState({ Label:me.state.requiredFields[i].props.Label+"*" });
                }
            }

            // for (let i = 0; i < me.state.requiredSelectField.length; i++){
            //   if (me.state.requiredSelectField[i].props.IsRequired){
            //     me.state.requiredSelectField[i].setState({ Label:me.state.requiredSelectField[i].props.Label + "*" });
            //   }
            // }
        }
      ); 

      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);
      
      this.Request2.setErrorHandler(()=>{
        this.setState({AddressID:0});
      });
      this.AddressModel.GetAdditionalAddressTypes();
     
      if (localStorage.getItem('vas_role') !== '1'){
        this.Request.setErrorHandler(()=>{});
        //this.CustomerModel.GetCustomerById(this.CustomerId);

        this.CustomerModel.GetCustomers(localStorage.getItem("SendData"),null,null,"name1",null,"Abo",null,null,null,null,null,localStorage.getItem("Number_CurrentCustomer"),null,null,null);
      }
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "StreetsCustomer"){

          let streetSelection = [];
  
          if(this.StreetsModel.Streets.length > 0){
  
            let streetArray = this.StreetsModel.Streets;

            for(let i = 0; i < streetArray.length; i++){
              streetSelection.push({ Key: streetArray[i], Display: streetArray[i] });
            }      
          }
  
          this.setState({StreetValues : streetSelection});
           if(this.refs.street){
             this.refs.street.setState({Data:streetSelection});
           }
  
          this.setState({oldZipstreet: this.StreetsModel.PostCode, oldCitystreet: this.StreetsModel.City });
        }

        else if(observer === "AddressTypes"){
          let AddressID = 0;
          if (this.AddressModel.AddressTypes){
            for (let i = 0; i< this.AddressModel.AddressTypes.length; i++){
                let value = this.AddressModel.AddressTypes[i];
                if (value.Name === "Erz1"){
                  AddressID = value.Id;    
                }
            }
          }
          this.setState({AddressID:AddressID});
        }
        else if(observer === "Customer"){
          let value = this.CustomerModel.Customer;
          me.setState({ CustomerText: 
            <table style={{ textAlign: "justify" }}>
              <thead>
                <tr>
                  <th colSpan={2}>{Vas.Resources.Labels["LegalGuardianFor"]}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {Vas.Resources.Labels["CustomerNumber"]}:
                  </td>
                  <td>
                    {value.CustomerNumber}
                  </td>
                </tr>
                <tr>
                  <td>
                    {Vas.Resources.Labels["Name"]}:
                  </td>
                  <td>
                    {value.Name1}
                  </td>
                </tr>
                <tr>
                  <td>
                    {Vas.Resources.Labels["FirstName"]}:
                  </td>
                  <td>
                    {value.Name2}
                  </td>
                </tr>
                <tr>
                  <td>
                    {Vas.Resources.Labels["Email"]}:
                  </td>
                  <td>
                    {value.Email}
                  </td>
                </tr>
              </tbody>
            </table>
          });
        }
        else if(observer === "NewAdditionalAddress"){
          Vas.GetView('CreateLegalGuardianSuccess', { CustomerId : me.CustomerId }, true);
        }
        else if(observer === "Streets"){
          me.refs.street.setState({ Data: this.StreetsModel.Streets, Icon :'',placeholder:'' });
          me.setState({ oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
        }
        else if(observer === "Customers"){
          if (this.CustomerModel.Customers)
          {         
              this.CustomerModel.Customers.forEach(function(value) {

                me.setState({ CustomerText: 
                  <table style={{ textAlign: "justify" }}>
                    <thead>
                      <tr>
                        <th colSpan={2}>{Vas.Resources.Labels["LegalGuardianFor"]}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["CustomerNumber"]}:
                        </td>
                        <td>
                          {value.CustomerNumber}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["Name"]}:
                        </td>
                        <td>
                          {value.Name1}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["FirstName"]}:
                        </td>
                        <td>
                          {value.Name2}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {Vas.Resources.Labels["Email"]}:
                        </td>
                        <td>
                          {value.Email}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                });

            });
          }
        }
      });
    }

    createLegalGuardian(){
      if (this.checkFields() === true){
                
        this.AddressModel.Address.AddressType = {
          Name : "Erz1",
          Id : this.state.AddressID
        };

        this.AddressModel.SetRequest(this.Request);
        this.AddressModel.SetNewAdditionalAddressByCustomerId(this.CustomerId);
      }
    }

    checkFields(){
        let count;

        if (this.state.requiredFields){
            count=this.state.requiredFields.length;
        }
        if (this.state.requiredFields){
            let filled=0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                      if(!(/^\s+$/).test(document.getElementById(this.state.requiredFields[i].props.Id).value)){
                        filled++;
                      }
                    }
                }
            }
              
          //   for (let k = 0; k < this.state.requiredSelectField.length;k++){
          //     if (this.state.requiredSelectField[k]){
          //         if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
          //             filled++;
          //         } 
          //     }
          // }
            if (filled < count){
              let docs = document.querySelectorAll('select,input');
              let docRefs = this.refs;
              CheckValues.checkAllFields(docs,docRefs,"");
              ReactDOM.render(<MessageBox 
                Message={Vas.Resources.Labels["NotAllFields"]} 
                Title={Vas.Resources.Titles["Note"]}
                />
                  ,document.getElementById('messageContainer'));
               return false;
            } else {
               return true;
            }
        }
    }

    getStreets()
    {
      let me = this;
      me.refs.street.setState({ Icon:"Loop" });

      if ((this.AddressModel.Address.Zip !== me.state.oldZip)||(this.AddressModel.Address.City !== me.state.oldCity)){
        me.refs.street.setState({ Data: [], Icon : '' });
        document.getElementById("Street").value = '';
      }

      if (this.AddressModel.Address.City || this.AddressModel.Address.Zip){
        let city = '';
        let zip = '';
        if (this.AddressModel.Address){
          city=this.AddressModel.Address.City;
        } 
        if (this.AddressModel.Address.Zip){
          zip=this.AddressModel.Address.Zip;
        } 

        this.Request.setErrorHandler(()=>{});
        this.StreetsModel.GetStreets(city,zip);
      }
    }

    render(){

      let min = moment();
      let maxValueLegalGuardian = moment([min.year() - 24, min.month(), min.date() + 1]);
    return (

      //TODO:
      //table -> div
      //h -> div
      //tr -> div Container
      //td -> div ContainerLeft bzw. div ContainerRight

      <div>
        <div className={"customerCard legalGuardianForm"} style={{ width:'400px',display:'inline-block',overflowY:'hidden',padding:"25px" }}>
          <div><h2>{Vas.Resources.Labels["LegalGuardian2"]}</h2></div>

            <div className={"ContainerHead"}>
         
              <div>{this.state.CustomerText}<br /><br /></div>

            </div>

            <div className={"ContainerBody"}>

              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <TextField
                    AppURL={Vas.ApplicationUrl}
                    ref={"name"}
                    Editable={true}
                    IsRequired={true}
                    Id={"Name1"}
                    Label={Vas.Resources.Labels["Name"]}
                    OnBlur={()=>{ this.AddressModel.Address.Name1 = $("#Name1").val(); }} />
                </div>
                <div className={"ContainerRight"}>
                  <TextField
                    AppURL={Vas.ApplicationUrl}
                    ref={"firstName"}
                    Editable={true}
                    IsRequired={true}
                    Id={"Name2"}
                    Label={Vas.Resources.Labels["FirstName"]}
                    OnBlur={()=>{ this.AddressModel.Address.Name2 = $("#Name2").val(); }} />
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <SelectField 
                    AppURL={Vas.ApplicationUrl} 
                    Data={[{ Key: 'männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'weiblich', Display: Vas.Resources.Labels["Female"] }]}
                    Id={"Gender"}
                    IsRequired={false}
                    Label={Vas.Resources.Labels["Gender"]}
                    OnBlur={()=>{this.AddressModel.Address.Gender = TranslateGender.Translate($("#Gender").val(),localStorage.getItem('vas_language'));}}
                    ref={"gender"}
                    Tooltip={Vas.Resources.Tooltips["Gender"]}
                    SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/>
                </div>
                <div className={"ContainerRight"}>
                  <DateField 
                    AppURL={Vas.ApplicationUrl}
                    Editable={true}
                    FalseDateText={Vas.Resources.Labels["DateNotValid"]}
                    FalseDateTitle={Vas.Resources.Titles["Note"]}
                    Id={"DateOfBirth"}
                    IsRequired={true}
                    Label={Vas.Resources.Labels["DateOfBirth"]}
                    Language={localStorage.getItem("vas_language")}
                    MaxValue={maxValueLegalGuardian}
                    OnBlur={()=>{
                      let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language')) ;
                      this.AddressModel.Address.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00"); 
                    }}
                    ref={"dateOfBirth"}
                    Tooltip={Vas.Resources.Tooltips["DateOfBirth"]}
                    FalseMaxDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}
                    FalseMinDateText={Vas.Resources.Labels["LegalGuardianDateOfBirthInvalid"]}/>
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"zip"}
                  Editable={true}
                  Id={"Zip"}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Zip"]}
                  OnBlur={()=>{ this.AddressModel.Address.Zip = $("#Zip").val();this.getStreets(); }}/>
                </div>
                <div className={"ContainerRight"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"city"}
                  Editable={true}
                  Id={"City"}
                  IsRequired={true}
                  Label={Vas.Resources.Labels["Place"]}
                  OnBlur={()=>{ this.AddressModel.Address.City = $("#City").val();this.getStreets();  }}/> 
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeftStreet"}>
                  <SelectField 
                    AppURL={Vas.ApplicationUrl}
                    editable={true}
                    Float={'left'}
                    Id={"Street"}
                    IsRequired={true} 
                    Label={Vas.Resources.Labels["Street"]}
                    MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
                    Modus={"Street"}
                    OnBlur={()=>{this.AddressModel.Address.Street = $("#Street").val(); }}
                    ref={"street"}
                    TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
                    Tooltip={Vas.Resources.Tooltips["Street"]}  
                    Width={346}
                    Data={this.StreetValues}
                    TimeOutTime={Vas.TimeOutTime}/>
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"houseNumber"}
                  Editable={true}
                  IsRequired={true}
                  Id={"HouseNumber"}
                  Label={Vas.Resources.Labels["HouseNumber"]}
                  OnBlur={()=>{ this.AddressModel.Address.HouseNumber = $("#HouseNumber").val(); }} />
                </div>
                <div className={"ContainerRight"}>
                  <TextField
                  AppURL={Vas.ApplicationUrl}
                  ref={"houseNumberAddition"}
                  Editable={true}
                  IsRequired={false}
                  Id={"HouseNumberAddition"}
                  Label={Vas.Resources.Labels["HouseNumberAddition"]}
                  OnBlur={()=>{ this.AddressModel.Address.HouseNumberAddition = $("#HouseNumberAddition").val(); }} />
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeftValidFrom"}>
                  <DateField 
                  AppURL={Vas.ApplicationUrl}
                  Editable={true}
                  FalseDateText={Vas.Resources.Labels["DateNotValid"]}
                  FalseDateTitle={Vas.Resources.Titles["Note"]}
                  Id={"ValidFrom"}
                  IsRequired={false}
                  Label={Vas.Resources.Labels["ValidFrom"]}
                  Language={localStorage.getItem("vas_language")}
                  MinValue={moment()}
                  OnBlur={()=>{
                    let cur = DateTimeHelper.StringToDate($("#ValidFrom").val(),false,localStorage.getItem('vas_language')) ;
                    this.AddressModel.Address.ValidFrom = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DD T 00:00:00"); 
                  }}
                  ref={"validFrom"}
                  FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
                  FalseMinDateText={Vas.Resources.Labels["InvalidDateOfBirth"]}/>
                </div>
              </div>
              <div className={"Container"}>
              <div className={"ContainerLeftHint"} style={{ textAlign:'left'}}>
                  <b>{Vas.Resources.Titles["Note"]}: </b><i className={'HintFormat'}>{Vas.Resources.Labels["NoteDateLegalGuardian"]}</i>
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <br />
                  <div style={{ float:'left' }}>{Vas.Resources.Labels["RequiredField"]}</div>
                </div>
              </div>
              <div className={"Container"}>
                <div className={"ContainerLeft"}>
                  <br />
                  <ExtendedButton
                  ref={"Create"}
                  Text={Vas.Resources.Labels["Add"]}
                  Float={'left'}
                  OnClick={()=>{ this.createLegalGuardian();}} 
                  Usable={true}/>
                </div>
                <div className={"ContainerRight"}>
                  <br />
                  <ExtendedButton
                  ref={"Close"}
                  Text={Vas.Resources.Labels["Cancel"]}
                  Float={'left'}
                  OnClick={()=>{ Vas.GetView("CustomerCardData", { Id :this.CustomerId }, true);}} 
                  Usable={true}/>
                </div>
              </div>

            </div>

        </div>
      </div>       
        );
    }
}
export default CreateLegalGuardian;
